import { flatten, uniq } from 'lodash';

import { ItineraryLegModel } from '@/lib/models/itinerary/types';

export const getKeyItineraryLocations = (legs: ItineraryLegModel[]): string[] => {
  const locations = legs.map((leg) => [leg.fromId, leg.toId]);
  return uniq(flatten(locations));
};
